import { LocalizationLanguage } from "@green0meter/api-client";

export const DM_SUPPORTED_LANGUAGES: {
  id: LocalizationLanguage;
  code: string;
  label: string;
}[] = [
  { id: LocalizationLanguage.EN, code: "en", label: "English" },
  { id: LocalizationLanguage.CZ, code: "cs", label: "Čeština" },
  { id: LocalizationLanguage.SK, code: "sk", label: "Slovenčina" },
  { id: LocalizationLanguage.DE, code: "de", label: "Deutsch" },
  { id: LocalizationLanguage.BG, code: "bg", label: "Български" },
  { id: LocalizationLanguage.RO, code: "ro", label: "Română" },
  { id: LocalizationLanguage.HU, code: "hu", label: "Magyar" },
  { id: LocalizationLanguage.PL, code: "pl", label: "Polski" },
];

export const DM_RANGE_KEYS = [
  "scale",
  "scope",
  "remediability",
  "likelihood",
  "intensity",
  "timeHorizon",
  "riskLikelihood",
  "riskMagnitude",
  "riskTimeHorizon",
  "opportunityLikelihood",
  "opportunityMagnitude",
  "opportunityTimeHorizon",
] as const;

export type DmRangeKey = (typeof DM_RANGE_KEYS)[number];

